export default function () {
  return {
    consultaHistorico: [],
    valorPedidoEprotocolo: '6,53',
    valorPesquisaDinamica: '10,88',
    valorConsulta: '31,45',
    valorImagem: '14,05',
    link_tabela_custa: 'https://corregedoria-mc.tjmt.jus.br/corregedoria-arquivos-prod/cms/Provimento_n_49_2024_CGJ_ad2c4f9a92.pdf',
  };
}
